import { render, staticRenderFns } from "./CookiePreferences.vue?vue&type=template&id=2585b95e&scoped=true"
import script from "./CookiePreferences.vue?vue&type=script&lang=js"
export * from "./CookiePreferences.vue?vue&type=script&lang=js"
import style0 from "./CookiePreferences.vue?vue&type=style&index=0&id=2585b95e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2585b95e",
  null
  
)

export default component.exports